<template>
  <div class="animated fadeIn pb-8">
    <div v-if="loadingData">
      <v-card class="common-card delivery-costs">
        <div class="d-flex flex-column align-items-center mt-8 py-6">
          <atom-spinner
            :animation-duration="1000"
            :size="80"
            :color="'#7c4dff'"
          />
          <p class="primary--text font-weight-bold mt-4">
            در حال بارگذاری اطلاعات...
          </p>
        </div>
      </v-card>
    </div>
    <div v-else>
      <v-card class="common-card delivery-costs">
        <div class="d-flex flex-row">
          <h4 class="c-grey pt-2 ps-2">مدیریت هزینه‌های ارسال</h4>
        </div>
        <hr class="mb-0 pb-0" />
        <v-card flat>
          <v-container>
            <div class="box pa-4 mt-4">
              <div class="box-title shopPrimary--text">هزینه ارسال با پست</div>
              <v-row>
                <v-col sm="6" cols="12">
                  <vuetify-money
                    v-model.number="fixedShippingCost"
                    :valueWhenIsEmpty="whenIsEmpty"
                    :options="vMoneyOptions"
                    hide-details
                    class="mt-4"
                    type="number"
                    outlined
                    label="هزینه ثابت  (تومان)"
                  />
                </v-col>
                <v-col cols="12" xl="3" lg="3" md="3" sm="6" xs="12">
                  <v-btn
                    block
                    height="54"
                    class="shopPrimary white--text fs-large mt-4"
                    :disabled="!fixedShippingCost || updating"
                    @click="updateFixedShippingCost"
                  >
                    <span v-if="!updating">ویرایش هزینه ثابت</span>
                    <span v-else>در حال انجام...</span>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col sm="6" cols="12">
                  <vuetify-money
                    v-model.number="perItemShippingCost"
                    :valueWhenIsEmpty="whenIsEmpty"
                    :options="vMoneyOptions"
                    hide-details
                    class="mt-4"
                    type="number"
                    outlined
                    label="هزینه افزوده  (تومان) "
                  />
                </v-col>
                <v-col cols="12" xl="3" lg="3" md="3" sm="6" xs="12">
                  <v-btn
                    block
                    height="54"
                    class="shopPrimary white--text fs-large mt-4"
                    :disabled="!perItemShippingCost || updating"
                    @click="updatePerItemShippingCost"
                  >
                    <span v-if="!updating">ویرایش هزینه افزوده</span>
                    <span v-else>در حال انجام...</span>
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card>
      </v-card>
    </div>
  </div>
</template>
<script>
import Axios from "axios";
import { AtomSpinner } from "epic-spinners";
export default {
  components: {
    AtomSpinner,
  },
  data() {
    return {
      loadingData: false,
      fixedShippingCost: null,
      perItemShippingCost: null,
      updating: false,
    };
  },
  methods: {
    getOptions() {
      this.loadingData = true;
      Axios.get(this.baseUrl + "/satrapp/option/getOptions", {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("token"),
        },
      })
        .then((res) => {
          if (res.status == 200) {
            this.loadingData = false;
            this.fixedShippingCost = res.data.fixedShippingCost;
            this.perItemShippingCost = res.data.perItemShippingCost;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );

            this.toast(title, "error");
            this.loadingData = false;
          }
        })
        .catch((err) => {
     
          this.toast("خطا: " + err.response.data, "error");
          this.loadingData = false;
        });
    },
    updateFixedShippingCost() {
      this.updateShippingCost("fixedShippingCost", this.fixedShippingCost);
    },
    updatePerItemShippingCost() {
      this.updateShippingCost("perItemShippingCost", this.perItemShippingCost);
    },
    updateShippingCost(key, value) {
      this.updating = true;
      Axios.post(
        this.baseUrl + "/satrapp/option/newOption",
        {
          key: key,
          value: value.toString(),
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.getOptions();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );

            this.toast(title, "error");
          }
          this.updating = false;
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.updating = false;
        });
    },
  },
  mounted() {
    this.getOptions();
  },
};
</script>
<style lang="scss">
.delivery-costs {
  .box {
    border: 1px solid #ccc;
    border-radius: 12px;
    width: 100%;
    position: relative;
    min-height: 80px;
    .box-title {
      font-size: 1.2rem;
      position: absolute;
      top: -14px;
      right: 20px;
      padding: 0 15px;
      background-color: #fff;
    }
  }
}
</style>
